module.exports = __webpack_public_path__ + "img/NP9.2fe67587.jpeg";